import React, { useEffect } from 'react'
import { useReportFormInfo } from 'Pages/ReportsAlerts/Reports/@hooks'
import { reportFormData, useOfficePickup } from 'Pages/ReportsAlerts/Reports/@signals'
import { array, object } from 'yup'
import { AppAsyncOfficesAutocomplete } from '@components'
import { isEmpty } from '@ui-seeker/utils'

export default function OfficePickupField() {

	useEffect(() => {
		return () => {
			if (!isEmpty(reportFormData.value)) setIdOfficePickupInfo([])
		}
	}, [useOfficePickup.value])

	const {
		idOfficePickup,
		setIdOfficePickupInfo,
		error,
	} = useReportFormInfo(reportFormData.peek().idOfficePickup, 'idOfficePickup', object({ idOfficePickup: array().required('Must provide an office').min(1, 'Must provide an office') }))

	return <AppAsyncOfficesAutocomplete
		multiple
		label="Pickup Office"
		placeholder="Select a Pickup Office"
		value={idOfficePickup || []}
		error={error}
		onChange={e => setIdOfficePickupInfo(e.target.value)}
	/>
}